import axios from 'axios';
import { API_URL } from './api-url.config';
import { API } from './api.config';
import { PAYMENT_URL } from './payment.config';
import { trackSubscriptionPageView } from './subscriptionAnalytics';

export async function subscribeHandler() {
  const title = window.platform_info.title;
  const accessToken = JSON.parse(localStorage.getItem(`access_token_r_${title}`));

  try {
    const response = await axios.post(`${API_URL}auth/token/shortlived`, {
      token: accessToken
    });
    const shortLived = await response?.data.token;
    const encodedToken = btoa(shortLived);
    const platformRes = await API.get(`api/platforminfo`);
    const domain = await platformRes?.data.domain;
    // console.log(domain);
    if (shortLived) {
      trackSubscriptionPageView();
      window.location.href = `${PAYMENT_URL}?hash=${encodedToken}&url=${domain}`;
    }
  } catch (error) {
    console.log('Error getting token or platform', error);
  }
}

export async function tvodHandler({ contentId, isTvod }) {
  const id = Number(contentId);
  const title = window.platform_info.title;
  const accessToken = JSON.parse(localStorage.getItem(`access_token_r_${title}`));

  try {
    const response = await axios.post(`${API_URL}auth/token/shortlived`, {
      token: accessToken
    });
    const shortLived = await response?.data.token;
    const encodedToken = btoa(shortLived);
    const platformRes = await API.get(`api/platforminfo`);
    const domain = await platformRes?.data.domain;
    // console.log(domain);
    if (shortLived) {
      trackSubscriptionPageView();
      if (!isTvod) {
        window.location.href = `${PAYMENT_URL}?hash=${encodedToken}&url=${domain}&content_id=${id}&svod=true`;
      } else {
        window.location.href = `${PAYMENT_URL}?hash=${encodedToken}&url=${domain}&content_id=${id}&tvod=${isTvod}`;
      }
    }
  } catch (error) {
    console.log('Error getting token or platform', error);
  }
}

export async function socialSubscribeHandler() {
  const title = window.platform_info.title;
  const accessToken = JSON.parse(localStorage.getItem(`access_token_r_${title}`));

  try {
    const response = await axios.post(`${API_URL}auth/token/shortlived`, {
      token: accessToken
    });
    const shortLived = await response?.data.token;
    const encodedToken = btoa(shortLived);
    const platformRes = await API.get(`api/platforminfo`);
    const domain = await platformRes?.data.domain;
    // console.log(domain);
    if (shortLived) {
      window.location.href = `${PAYMENT_URL}?hash=${encodedToken}&url=${domain}&ref=entertainment`;
    }
  } catch (error) {
    console.log('Error getting token or platform', error);
  }
}

export async function postPayment(packageId, product) {
  try {
    const title = window.platform_info.title;
    const accessToken = JSON.parse(localStorage.getItem(`access_token_r_${title}`));
    const response = await axios.post(`${API_URL}auth/token/shortlived`, {
      token: accessToken
    });
    const shortLived = await response?.data?.token;

    const responseSSl = await axios.post(
      `${API_URL}payment/api/v2/pgw/${packageId}/subscription`,
      { productId: product },
      {
        headers: {
          Authorization: `Bearer ${shortLived}`
        }
      }
    );
    if (responseSSl.data.status === 400 && packageId === 'gpdcb') {
      console.error('Error redirecting due to bad api reponse');
      throw 400;
    }

    if (responseSSl?.data?.message) {
      window.location.replace(responseSSl?.data?.message);
      return;
    }

    console.error('Payment API response missing redirect URL');
  } catch (error) {
    if (error.response?.status === 400 && packageId === 'gpdcb') {
      console.error('API returned HTTP 400 for gpdcb');
      throw 400;
    }
    console.log('Error Posting to payment', error);
    throw error;
  }
}
